import { css } from "@compiled/react";

const priceDisplayStyles = css({
    alignSelf: "center",
    fontFamily: "Charlie Display",
    fontSize: "54px",
    fontWeight: "500",
    lineHeight: "54px",
    margin: "24px 0 8px",
    color: "#091e42"
});

export type PriceDisplayProps = {
    readonly formattedPrice: string;
    readonly fontSize: string;
    readonly planName: string;
};

export const PriceDisplay = ({
    formattedPrice,
    fontSize,
    planName
}: PriceDisplayProps) => (
    <div css={priceDisplayStyles}>
        <div
            data-cy={`plan-card-price-${planName.toLowerCase()}`}
            style={{ fontSize }}
        >
            {formattedPrice}
        </div>
    </div>
);
